import { Container } from "./styles";

export const LoadingLoop = () => {
    return <Container><div></div></Container>;
}
